import WelcomeBackHomepageFirstFoldComponent from "./welcome-back-homepage-first-fold-component";
import WelcomeBackHomepageFirstFoldConfig from "./welcome-back-homepage-first-fold-config";
import WelcomeBackHomepageFirstFoldAdvancedConfig from "./welcome-back-homepage-first-fold-advanced-config";

export default {
  WelcomeBackHomepageFirstFoldComponent,
  WelcomeBackHomepageFirstFoldConfig,
  WelcomeBackHomepageFirstFoldAdvancedConfig
};
